import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyOthersFailed() {
  return <Section bg="white" data-id="element-214">
      <div className="max-w-3xl mx-auto bg-[#FFF8F0] rounded-3xl p-8 md:p-10 border-2 border-[#F59E0B]/20 shadow-lg" data-id="element-215">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-[#422006]" data-id="element-216">
          Por qué lo que has intentado no funciona
        </h2>

        <ul className="space-y-6" data-id="element-217">
          <li className="flex items-start gap-4" data-id="element-218">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-219" />
            <p className="text-[#78350F] text-lg" data-id="element-220">
              <strong data-id="element-221">Los meal plans semanales</strong> te piden que cocines
              todo en un solo día, algo imposible cuando el domingo es tu único
              día de descanso.
            </p>
          </li>
          <li className="flex items-start gap-4" data-id="element-222">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-223" />
            <p className="text-[#78350F] text-lg" data-id="element-224">
              <strong data-id="element-225">Intentar improvisar</strong> cada noche desde cero te deja
              sin energía para compartir con tus hijos.
            </p>
          </li>
          <li className="flex items-start gap-4" data-id="element-226">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-227" />
            <p className="text-[#78350F] text-lg" data-id="element-228">
              <strong data-id="element-229">Recalentar la misma comida</strong> sin variarla le quita
              frescura y te hace sentir que comes “sobras”.
            </p>
          </li>
        </ul>
      </div>
    </Section>;
}